
(function () {
  function selectFirstColorVariant() {
    document
      .querySelectorAll(
        '.gbbVariantModalOptionPickers .gbbOptionPickerRow[data-display-style="SWATCH"]'
      )
      .forEach(function (row) {
        // Keep an already-selected color unchanged.
        if (row.querySelector('.gbbOptionPickerInput:checked')) {
          return;
        }

        // Select the first available color.
        const firstColor = row.querySelector(
          '.gbbOptionPickerInput:not(:disabled)'
        );

        if (firstColor) {
          firstColor.click();
        }
      });
  }

  // Remove unnecessary .00 from Easy Bundle Builder
  // discount messages only. Do not modify product prices.
  function formatBundleDiscountAmounts() {
    document
      .querySelectorAll('.gbbDiscountContainer')
      .forEach(function (container) {
        const walker = document.createTreeWalker(
          container,
          NodeFilter.SHOW_TEXT
        );

        const textNodes = [];
        let node;

        while ((node = walker.nextNode())) {
          textNodes.push(node);
        }

        textNodes.forEach(function (textNode) {
          const formattedText = textNode.nodeValue.replace(
            /(\d[\d,]*)\.00\b/g,
            '$1'
          );

          if (formattedText !== textNode.nodeValue) {
            textNode.nodeValue = formattedText;
          }
        });
      });
  }

  function initializeBundleBuilder() {
    selectFirstColorVariant();
    formatBundleDiscountAmounts();
  }

  // Initial page load.
  document.addEventListener(
    'DOMContentLoaded',
    initializeBundleBuilder
  );

  // Easy Bundle Builder dynamically updates its content.
  const observer = new MutationObserver(function () {
    initializeBundleBuilder();
  });

  if (document.body) {
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }
})();
